module.exports = __webpack_public_path__ + "img/icon-guiding.463538e2.png";